import { render, staticRenderFns } from "./EditSurveyStageHeaderTemplate.vue?vue&type=template&id=4bdb838e&scoped=true"
import script from "./EditSurveyStageHeaderTemplate.vue?vue&type=script&lang=js"
export * from "./EditSurveyStageHeaderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb838e",
  null
  
)

export default component.exports